<!-- Displaying a custom system message component -->
<!-- <app-system-message></app-system-message> -->

<!-- Mobile view for muirwood -->
@if (this.iotService.showDeviceConfigModal && this.cognitoService.userType === 'muirwood' && this.iotService.thingShadow?.state?.desired?.config) {
<div class="main-container" [ngClass]="theme.getThemeClass()" [style]="this.getDisplayByUserType()">
  <nav class="title">
      <h3>{{ "deviceConfigModalDeviceConfig" | translate }}</h3>
      @if (this.changeSaved) {
      <label class="updated">{{ "usereditFormLabelChangeConfirm" | translate }}</label>
      }
      <h5 class="model">{{ this.iotService.thingName}}</h5>
  </nav>
  <section class="block-left col-5">
      <article class="sleep" [ngClass]="theme.getThemeClass()">
          <label class="labelSleep col-7">{{ "deviceConfigModalSlp" | translate }}</label>
          <div class="col-5">
              <select class="col-12 form-control" [(ngModel)]="this.iotService.thingShadow.state.desired.config.slp">
                  @for (time of this.sleepTime; track time.value) {
                  <option [ngValue]="time.value" [selected]="time.value === this.iotService.thingShadow.state.desired.config.slp">{{ time.label | translate}}</option>
                  }
              </select>
          </div>
      </article>
      @for (trigger of [
        { key: 'dst', label: 'deviceConfigModalDistance' },
        { key: 'env', label: 'deviceConfigModalEnvironmentalMeter' },
        { key: 'voc', label: 'deviceConfigModalVOC' },
        { key: 'img', label: 'deviceConfigModalImg' },
        { key: 'lfr', label: 'deviceConfigModalLfr' },
        { key: 'gps', label: 'deviceConfigModalGps' },
        { key: 'gtc', label: 'deviceConfigModalGtc' }
      ]; track trigger.key) {
      <article class="trigger">
          <div class="card-title mt-0 status">
              <label class="switch col-2">
                  <input type="checkbox" [name]="'active-' + trigger.key" [(ngModel)]="this.iotService.thingShadow.state.desired.config[trigger.key]" (ngModelChange)="this.iotService.thingShadow.state.desired.config[trigger.key] = $event ? 1 : 0">
                  <span [ngClass]="{'active-checkbox': this.iotService.thingShadow.state.desired.config[trigger.key] === 1, 'inactive-checkbox': this.iotService.thingShadow.state.desired.config[trigger.key] === 0}"  class="slider round"></span>
              </label>
              <label class="toggle col-10">{{ trigger.label | translate }}</label>
          </div>
      </article>
      }
  </section>

  <section class="block-right col-7">
      <article class="sleep" [ngClass]="theme.getThemeClass()">
          <label class="labelSleep col-8">{{ "deviceConfigModalHit" | translate }}</label>
          <div class="col-4 inputBlockRight">
              <input type="number" class="hibernationTemp col-12 form-control" [(ngModel)]="this.iotService.thingShadow.state.desired.config.hit">
          </div>
      </article>
      <article class="sleep" [ngClass]="theme.getThemeClass()">
          <label class="labelSleep col-8">{{ "deviceConfigModalHis" | translate }}</label>
          <div class="col-4 inputBlockRight">
              <select [(ngModel)]="this.iotService.thingShadow.state.desired.config.his" class="col-12 form-control">
                  @for (time of sleepTime; track time.value) {
                    <option value="time.value[0]" [selected]="time.value === this.iotService.thingShadow.state.desired.config.his">{{ time.label | translate}}</option>
                  }
              </select>
          </div>
      </article>

    </section>
    <nav class="button col-4">
      <button [ngClass]="theme.getThemeClass()" class="btn" (click)="cancel()" type="button">{{ 'clientcreateFormBtnCancel' | translate }}</button>
      <button [ngClass]="theme.getThemeClass()" class="btn" (click)="onSubmit()" type="submit">{{ 'usereditFormLabelConfirm' | translate }}</button>
    </nav>

</div>
}


<!-- Desktop / general view -->
@if (this.iotService.showDeviceConfigModal && this.iotService.thingShadow?.state?.desired?.config) {
<div [ngClass]="theme.getThemeClass()" [style]="this.getDisplayByUserType()">
  <nav class="title">
    <h5 class="col-8">{{ "iotModalViewConfig" | translate }}</h5><label class="model col-4 model-number-title">{{ this.iotService.thingName}}</label>
  </nav>
  <section>
    @if (this.cognitoService.userType === 'muirwood') {
    <article class="sleep" [ngClass]="theme.getThemeClass()">
        <label class="labelSleep col-9">{{ "deviceConfigFirmwareVersion" | translate }}</label>
        <div class="col-3">
            <label class="col-12">{{ currentFirmwareVersion }}</label>
        </div>
    </article>
    }
      <article class="sleep" [ngClass]="theme.getThemeClass()">
          <label class="labelSleep col-9">{{ "deviceConfigModalSlp" | translate }}</label>
          <div class="col-3">
              <select class="col-12 form-control" [(ngModel)]="this.iotService.thingShadow.state.desired.config.slp">
                  @for (time of this.sleepTime; track time.value) {
                    @if (time.value !== 300 || (time.value === 300 && this.cognitoService.userType === 'muirwood')) {
                      <option [ngValue]="time.value" [selected]="time.value === this.iotService.thingShadow.state.desired.config.slp">{{ time.label | translate}}</option>
                    }
                  }
              </select>
          </div>
      </article>
      <article class="sleep" [ngClass]="theme.getThemeClass()">
          <label class="labelSleep col-9">{{ "deviceConfigModalHit" | translate }}</label>
          <div class="col-3">
              <input type="number" class="hibernationTemp col-12 form-control" [(ngModel)]="this.iotService.thingShadow.state.desired.config.hit" [disabled]="this.cognitoService.userType !== 'muirwood'">
          </div>
      </article>
      <article class="sleep" [ngClass]="theme.getThemeClass()">
          <label class="labelSleep col-9">{{ "deviceConfigModalHis" | translate }}</label>
          <div class="col-3">
              <select [(ngModel)]="this.iotService.thingShadow.state.desired.config.his" class="col-12 form-control" [disabled]="this.cognitoService.userType !== 'muirwood'">
                  @for (time of this.sleepTime; track time.value) {
                    @if (time.value !== 300 || (time.value === 300 && this.cognitoService.userType === 'muirwood')) {
                      <option [ngValue]="time.value" [selected]="time.value === this.iotService.thingShadow.state.desired.config.his">{{ time.label | translate}}</option>
                    }
                  }
              </select>
          </div>
      </article>

  <article class="sleep" [ngClass]="theme.getThemeClass()">
    <label class="labelSleep col-9">{{ "deviceGroup" | translate }}</label>
    <div class="col-3 ">
        <select
        class="col-12 form-control"
        name="deviceGroup"
        [(ngModel)]="selectedDeviceGroup"
      >
        <option value="" disabled selected>
          {{ "devicecreateSelectGroup" | translate }}
        </option>
        @for (groups of thingGroups; track groups) {
        <option
            [value]="groups"
            [disabled]="disabledOption === groups"
            >
          {{ groups }}
        </option>
        }
      </select>
    </div>
</article>

  <article  class="sleep" [ngClass]="theme.getThemeClass()">
    <label class="labelSleep col-9">{{ "deviceDesiredFirmwareVersion" | translate }}</label>
    <div class="col-3">
      <select
        [disabled]="!enableUpdate || cognitoService.userType !== 'muirwood'"
        [(ngModel)]="desiredFirmwareVersion"
        class="col-12 form-control"
        [class.grayed-out]="!enableUpdate"
        (change)="firmwareChange($any($event.target).value)"
      >
        <option value="">{{ 'deviceDesiredFirmwareVersion' | translate }}</option>
        @for (version of iotService.firmwareVersionArray; track version.version) {
          <option [value]="version.version">{{ version.version }}</option>
        }
      </select>
    </div>
  </article>

  <article  class="sleep" [ngClass]="theme.getThemeClass()">
    <label class="labelSleep col-9">{{ "updateLibraries" | translate }}</label>
    <div class="col-3">
      <input 
        type="checkbox" 
        [(ngModel)]="uptLibraries"
        [disabled]="!enableUpdate || cognitoService.userType !== 'muirwood'">
    </div>
  </article>

      @if (this.cognitoService.userType === 'muirwood') {
      <article class="trigger">
          <div class="card-title mt-0 status">
          <label class="switch col-2">
              <input type="checkbox" id="enableUpdateCheckbox" (change)="toggleEnableUpdate($event)">
              <span [ngClass]="this.enableUpdate == true ? 'active-checkbox' : 'inactive-checkbox'"  class="slider round"></span>
          </label>
          <label class="toggle col-10">{{ "enableDeviceUpdate" | translate }}</label>
          </div>
      </article>
      @for (trigger of [
        { key: 'dst', label: 'deviceConfigModalDistance' },
        { key: 'env', label: 'deviceConfigModalEnvironmentalMeter' },
        { key: 'voc', label: 'deviceConfigModalVOC' },
        { key: 'img', label: 'deviceConfigModalImg' },
        { key: 'lfr', label: 'deviceConfigModalLfr' },
        { key: 'gps', label: 'deviceConfigModalGps' },
        { key: 'gtc', label: 'deviceConfigModalGtc' }
      ]; track trigger.key) {
      <article class="trigger">
          <div class="card-title mt-0 status">
              <label class="switch col-2">
                  <input type="checkbox" [name]="'active-' + trigger.key" [(ngModel)]="this.iotService.thingShadow.state.desired.config[trigger.key]" (ngModelChange)="this.iotService.thingShadow.state.desired.config[trigger.key] = $event ? 1 : 0">
                  <span [ngClass]="{'active-checkbox': this.iotService.thingShadow.state.desired.config[trigger.key] === 1, 'inactive-checkbox': this.iotService.thingShadow.state.desired.config[trigger.key] === 0}"  class="slider round"></span>
              </label>
              <label class="toggle col-10">{{ trigger.label | translate }}</label>
          </div>
      </article>
      }
      }
  </section>

  <nav class="form-group button ">
      <button [ngClass]="theme.getThemeClass()" class="btn" (click)="cancel()" type="button">{{ 'clientcreateFormBtnCancel' | translate }}</button>
      <button [ngClass]="theme.getThemeClass()" class="btn" (click)="onSubmit()" type="submit">{{ 'usereditFormLabelConfirm' | translate }}</button>
  </nav>
</div>
}
